module.exports = __webpack_public_path__ + "img/collection-memoireRingsAsWeddingRings.42a2581.jpg";